import React from 'react';
import { useRecordContext } from 'react-admin';
import { leadsFields } from '../leads.model';
import EmptyField from '@/material/emptyField.component';

const AddressField = (props) => {
  const record = useRecordContext();

  if (!record) return <EmptyField />;

  const { address, city, state, zip_code } = record;

  // Build complete address string
  const addressParts = [address, city, state, zip_code].filter(Boolean); // Remove empty/null values

  if (addressParts.length === 0) {
    return <EmptyField />;
  }

  const completeAddress = addressParts.join(', ');

  return (
    <span {...props} title={completeAddress}>
      {completeAddress}
    </span>
  );
};

export default AddressField;
